import { WeddingLogo } from "./WeddingLogo";

export function AiFabLogo() {
  return <WeddingLogo size={40} className="ai-fab-logo" />;
}
